import httpRequest from "@/auth/http-client";

class CampaignSegmentService {
  private baseUrl = "api/v1/campaignsegment";

  async delete(segmentId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${segmentId}`);
  }
}

const campaignSegmentService = new CampaignSegmentService();
export default campaignSegmentService;
